import { createSlice } from "@reduxjs/toolkit";

export type WindowSizeDT = {
  width: number;
  height: number;
}
export const windowSizeHandleSlice = createSlice({
  name: "windowSizeHandle",
  initialState: {
    windowSize: {
      width: 0,
      height: 0,
    } as WindowSizeDT
  },
  reducers: {
    setSize: (state, payload) => {
      state.windowSize = payload.payload;
    },
    resetSize: (state) => {
      state.windowSize = {
        width: 0,
        height: 0,
      };
    },
  },
});

// 为每个 case reducer 函数生成 Action creators
export const { setSize, resetSize } =
  windowSizeHandleSlice.actions;

export default windowSizeHandleSlice.reducer;
